import { Divider, IconButton, Menu, MenuItem } from '@mui/material'
import { Fragment, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { IconMenuHamburger } from '../../../icons/IconMenuHamburger'
import { COLORS } from '../../../styles/variables'
import {
  GUEST_HEADER_LEGAL_LINKS,
  GUEST_HEADER_MENU_LINKS,
  GUEST_MENU_INFO_LINKS,
} from '../guestNavLinks'

export const GuestHeaderLegalMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const infoLinksCount = GUEST_MENU_INFO_LINKS.length

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        aria-label="Информация и документы"
        aria-controls={open ? 'guest-header-legal-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpen}
        sx={{
          p: 0.5,
          color: COLORS.BLACK,
          '&:hover': {
            bgcolor: 'transparent',
            color: COLORS.CHARCOAL_GREY,
          },
        }}
      >
        <IconMenuHamburger fontSize="medium" />
      </IconButton>

      <Menu
        id="guest-header-legal-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              maxWidth: 320,
              borderRadius: '12px',
              mt: 1,
            },
          },
        }}
      >
        {GUEST_HEADER_MENU_LINKS.map((link, index) => (
          <Fragment key={link.path}>
            {index === infoLinksCount && GUEST_HEADER_LEGAL_LINKS.length > 0 && (
              <Divider sx={{ my: 0.5 }} />
            )}
            <MenuItem
              component={RouterLink}
              to={`/${link.path}`}
              onClick={handleClose}
              sx={{ fontSize: 14, whiteSpace: 'normal', lineHeight: 1.4, py: 1.25 }}
            >
              {link.label}
            </MenuItem>
          </Fragment>
        ))}
      </Menu>
    </>
  )
}
